import { toast } from "react-toastify";
import apiClient, { imageClient } from "./apiClient";
import axios from "axios";

/**
 * Append Details API For Host and Merchant
 * @param {string} userType - The type of user (e.g., "merchant", "host").
 * @param {string} id - The ID of the user.
 * @param {any} data - The data to be appended.
 * @returns {Promise<any>} - The response data.
 * @throws {Error} - If there's an error during the API call.
 **/
export const createTrip = async (data: any) => {
  try {
    // const type = userType=== "Host"? "Hosts" : "Merchants";
    const response = await apiClient.post(`/Trips`, data);
    return response.data;
  } catch (error) {
    console.error("Error appending details:", error);
    throw error;
  }
};

export const getTrips = async (status: string,merchantId:string) => {
  try {
    const data = {
      filterParams: {
        IndexName: "merchantId-tripApprovalStatus-index",
        KeyConditionExpression:
          "merchantId = :merchantId and tripApprovalStatus = :tripApprovalStatus ",
        ExpressionAttributeValues: {
          ":merchantId": merchantId,
          ":tripApprovalStatus": status,
        },
      },
    };
    // const type = userType=== "Host"? "Hosts" : "Merchants";
    const response = await apiClient.post(`/Trips/bulk-ops/query`, data);
    if (response.status === 200) {
      toast.success("Trips fetched successfully");
      return response.data;
    }
  } catch (error) {
    console.error("Error appending details:", error);
    throw error;
  }
};

export const getTripDetails = async (id: string) => {
  try {
    const response = await apiClient.get(`/Trips/id/${id}`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error("Error fetching trip details:", error);
    throw error;
  }
};

export const updateTrips = async (id: string, data: any) => {
  try {
    const response = await apiClient.put(`/Trips/id/${id}`, data);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error("Error updating trip:", error);
    throw error;
  }
};

export const fetchSlot = async (id: string) => {
  try {
    const data = {
      filterParams: {
        IndexName: "hostId-index",
        KeyConditionExpression: "hostId = :hostId",
        ExpressionAttributeValues: {
          ":hostId": id,
        },
      },
    };
    const response = await apiClient.post(`/TripSlots/bulk-ops/query`, data);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error("Error Fetching slots:", error);
    throw error;
  }
};

export const getSlots = async (tripId: string) => {
  try {
    const data = {
      filterParams: {
        IndexName: "tripId-index",
        KeyConditionExpression: "tripId = :tripId",
        ExpressionAttributeValues: {
          ":tripId": tripId,
        },
      },
    };

    const response = await apiClient.post(`/TripSlots/bulk-ops/query`, data);
    if (response.status === 200) {
      return response;
    }
    return response;
  } catch (error) {
    console.error("Error getting slots:", error);
  }
};

export const addSlots = async (data: any) => {
  try {
    const response = await apiClient.post(`/TripSlots`, data);
    return response;
  } catch (error) {
    console.error("Error adding slots:", error);
    throw error;
  }
};

export const updateSlots = async (id: string, data: any) => {
  try {
    const response = await apiClient.put(`/TripSlots/id/${id}`, data);
    return response;
  } catch (error) {
    console.error("Error updating slots:", error);
    throw error;
  }
};

/**
 * @param {string} folderName - Foldername unique combination of trips(searchidkey + searchid).
 * @param {string} fileName - File name of the image to be uploaded to S3. It's also needed when fetching image.
 * @returns {Promise<any>} - The response data { uploadURL : string, filePath: string }.
 **/

export const createImageUrl = async (folderName: string, fileName: string) => {
  try {
    const response = await apiClient.post(
      `/s3/folder/${folderName}/file/${fileName}/upload`
    );
    return response.data;
  } catch (error) {
    console.error("Error getting url", error);
    throw error;
  }
};

/**
 * @param {File} file - The file to be uploaded to S3.
 * @param {string} url - The URL to upload the file to.
 * @param {string} mimetype - The mimetype of the file to be uploaded to S3.
 * @returns {Promise<any>} - Status code 200 if successful.
 **/
export const uploadImage = async (
  file: File,
  url: string,
  mimetype: string
) => {
  try {
    const response = await axios.put(url, file, {
      headers: {
        "Content-Type": mimetype,
      },
    });
    return response;
  } catch (error) {
    console.error("Error uploading image", error);
    throw error;
  }
};

/**
 * @param {string} folderName - Foldername unique combination of trips(searchidkey + searchid).
 * @param {string} fileName - File name of the image to be uploaded to S3. It's also needed when fetching image.
 * @returns {Promise<any>} - The response data file from s3.
 **/
export const getImage = async (folderName: string, fileName: string) => {
  try {
    const response = await imageClient.get(`/${folderName}/${fileName}`);
    return response.data;
  } catch (error) {
    console.error("Error getting image", error);
    return null;
  }
};
